<template>
  <div>
    <div id="legendBg" :style="{height:getLengtHeight}"></div>
    <div id="legendContent">
      <div id="legendTitle">图例</div>
      <div v-for="(item,index) in legends" class="legendItem" :key="index">
        <div class="legendItemSymbol"  :style="{backgroundColor:item.color}" ></div>
        <span class=lengendItemTitle> {{item.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MapLegend",
    props:{
      legends:{
        type: Array,
        required:true,
        default:function () {
          return [
            {color:"#A5F196",title:"0~10 毫米"},
            {color:"#3DA61C",title:"10~25 毫米"},
            {color:"#66B8FC",title:"25~50 毫米"},
            {color:"#0D23F9",title:"50~100 毫米"},
            {color:"#F727F7",title:"100~250 毫米"},
            {color:"#E64E4E",title:">250 毫米"}
          ];
        }
      }
    },
    data:function () {
      return{
      };
    },
    mounted() {

    },
    computed:{
      getLengtHeight:function(){
       return 40 + this.legends.length * 25 + 25 +"px"
      }
    }
  }
</script>

<style scoped>

  #legendBg{
    background-color: black;
    width: 100%;
    z-index: 1;opacity: 0.5;
  }

  #legendContent
  {
    background-color: transparent;
    text-align: left;
    width: 100%;
    height: auto;
    z-index: 2;
    position: absolute;
    left: 0px;
    top: 0px;
    padding: 0px 15px;
  }

  #legendTitle{
    font-size: 20px; height:40px; line-height: 40px; color: yellow;
  }

  .legendItem{
    color: red;
    text-align: left;
    position: relative;
    display: flex;
    margin-bottom: 10px;

  }

  .legendItemSymbol{
    width: 30px;
    height: 15px;
    border-radius: 1px;
  }
  .lengendItemTitle{
    margin-left: 10px;
    color: white;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/components/map/MapLegend.vue